import React from 'react'
import {Box} from '@chakra-ui/react'
import PropTypes from 'prop-types'
import {renderLayoutsSwitch} from '../../utils/contentRenderer'
const CartPage = ({content, area}) => {
    const renderArea = (areaContent) => {
        return areaContent.map((content, contentIndex) => (
            <React.Fragment key={contentIndex}>{renderLayoutsSwitch(content)}</React.Fragment>
        ))
    }

    return (
        <Box>
            {area === 'TopArea' && content?.TopArea && renderArea(content.TopArea)}
            {area === 'BottomArea' && content?.BottomArea && renderArea(content.BottomArea)}
        </Box>
    )
}

CartPage.displayName = 'CartPage'

CartPage.propTypes = {
    content: PropTypes.object,
    area: PropTypes.oneOf(['TopArea', 'BottomArea'])
}

export default CartPage
